export default __webpack_public_path__ + "static/media/search-icon.5b78c042.png";